'use client'

import { ThemeProvider } from 'next-themes'
import { SupabaseAuthProvider } from '@/components/providers/supabase-auth-provider'
import { useState, useEffect } from 'react'
import { ErrorBoundary } from '@/components/error-boundary'
import { Loader2 } from 'lucide-react'

function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
        <p className="text-lg text-muted-foreground">Loading application...</p>
      </div>
    </div>
  )
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Just a small delay to ensure everything is loaded
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 300)
    
    return () => clearTimeout(timer)
  }, [])

  return (
    <ErrorBoundary>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <SupabaseAuthProvider>
          {isLoading ? <LoadingScreen /> : children}
        </SupabaseAuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
} 